import { createFileRoute, Outlet } from '@tanstack/react-router';
export const Route = createFileRoute('/bulk-import/imports')({ component: Outlet });
